import React, { useEffect } from 'react';
import { navigate } from 'gatsby';
import PropTypes from 'prop-types';

import { pushGTMWaitlistSuccessEvent, pushGTMWaitlistFailureEvent } from 'utils/gtm';
import leadService from 'services/LeadService';

import StepHeader from '../../shared/StepHeader';
import PersonalForm from '../../shared/PersonalForm';
import { StyledContainer } from '../styles';

const VariantA = ({ data, locationHeading, locationCode, serviceName, waitlistSuccessLink, waitlistFailureLink }) => {
  // We are in the "/booking" flow
  async function onFormSubmit(submitData) {
    try {
      const res = await leadService.sendLeadData({ formData: submitData });

      const { masterId } = res;
      await leadService.updateWaitlistLeadStatus(masterId, locationCode);
      pushGTMWaitlistSuccessEvent(locationCode);
      navigate(waitlistSuccessLink);
    } catch (error) {
      pushGTMWaitlistFailureEvent(locationCode);
      navigate(waitlistFailureLink);
    }
  }

  useEffect(() => {
    leadService.getLeadToken();
  }, []);

  return (
    <StyledContainer>
      <StepHeader
        title={data?.title}
        locationHeading={locationHeading}
        serviceName={serviceName}
        hasBorder={data?.hasBorder}
      />
      <PersonalForm onFormSubmit={onFormSubmit} formData={data} />
    </StyledContainer>
  );
};

VariantA.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    ageConsentLabel: PropTypes.string,
    bookButtonLabel: PropTypes.string,
    email: PropTypes.string,
    firstNameLabel: PropTypes.string,
    hasBorder: PropTypes.bool,
    lastNameLabel: PropTypes.string,
    phoneNumber: PropTypes.string,
    userConsent: PropTypes.object,
  }),
  locationHeading: PropTypes.string,
  locationCode: PropTypes.string,
  serviceName: PropTypes.string,
  waitlistSuccessLink: PropTypes.string,
  waitlistFailureLink: PropTypes.string,
};

export default VariantA;
